import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { divisions } from "../../../utils/PositionStateData";

export default function OfferModal({
  open,
  onClose,
  onSubmit,
  offerRegister,
  resetOffer,
  dateYear,
  loading,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="max-w-lg space-y-4 border bg-white rounded-lg">
          <div className="p-8">
            <DialogTitle className="text-xl uppercase pb-4">
              New Offer
            </DialogTitle>
            <form onSubmit={onSubmit}>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-4">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="schoolName"
                  >
                    School
                  </label>
                  <input
                    id="schoolName"
                    type="text"
                    {...offerRegister("schoolName", {
                      required: "School is required",
                    })}
                    placeholder="School..."
                    className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                  />
                </div>
                <div className="w-full px-3 mb-4">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="division"
                  >
                    Division
                  </label>
                  <select
                    id="division"
                    {...offerRegister("division", {
                      required: "Division is required",
                    })}
                    className="form-select bg-no-repeat block appearance-none w-full border border-gray-300 text-gray-900 p-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white"
                  >
                    {divisions.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                    htmlFor="offerYear"
                  >
                    Year
                  </label>
                  <input
                    id="offerYear"
                    type="number"
                    min={2000}
                    max={dateYear}
                    {...offerRegister("offerYear", {
                      required: "Year is required",
                    })}
                    defaultValue={dateYear}
                    placeholder="Year..."
                    className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-3 leading-tight focus:outline-none focus:bg-white"
                  />
                </div>
              </div>
              <div className="form-field mt-4">
                {loading && <LoadingSpinner />}
              </div>
              <div className="flex gap-4 bg-gray-50 sm:flex sm:flex-row-reverse p-4">
                <button
                  type="submit"
                  className="bg-red-500 text-white p-3 px-10 rounded-md uppercase text-sm hover:bg-red-700 ml-3"
                >
                  Add
                </button>
                <button
                  type="reset"
                  onClick={() => {
                    onClose();
                    resetOffer();
                  }}
                  className="text-gray-600 font-semibold hover:text-gray-800"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
